/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import api from 'api';
import {
  Container,
  LoadingArea,
  ButtonArea,
  Printable,
  PrintStyles,
  Header,
  HrHeader,
  Footer,
  FooterRow,
  LogoIcon,
  Row,
  SectionContainer,
  SectionTitle,
  FooterText,
} from './styles';
import { formatCPF, formatCNPJ, formatPhone, formatCurrency } from 'react-data-formatter';
import { loadingColor, white } from 'styles/colorProvider';
import { Button } from 'components';
import { MdChevronLeft } from 'react-icons/md';
import { BsPrinter } from 'react-icons/bs';
import { toast } from 'react-toastify';

function PolicySupplementaryDocument({ location, history }) {
  const policyId = parseInt(location.pathname.split('/detalhes-do-contrato/')[1]);

  const [policyData, setPolicyData] = useState({});
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await api({
        method: 'GET',
        url: `/policy-product-partner/${policyId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitriskwl-authtoken'),
        },
        json: true,
      });

      setPolicyData(response.data);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro carregando os produtos!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }

    setLoading(false);
  };

  useEffect(() => loadData(), []);

  const originalValue = policyData?.policy?.value_final || 0;
  const percentageProducts = policyData?.products?.filter((product) => product.value_type === 'percentage') || [];

  const calculatedValuesSum = percentageProducts.reduce(
    (sum, product) => sum + (product.calculated_value || (product.value * originalValue) / 100),
    0,
  );
  const finalValue = originalValue + calculatedValuesSum;

  return (
    <>
      <PrintStyles />
      {!loading && (
        <ButtonArea>
          <Button style={{ color: white }} height="30px" width="130px" onClick={() => window.print()}>
            <BsPrinter size="15" style={{ marginRight: 10 }} />
            Imprimir
          </Button>
        </ButtonArea>
      )}
      {loading && (
        <LoadingArea>
          <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
        </LoadingArea>
      )}
      {!loading && (
        <Container>
          <Printable>
            <Header>
              <div className="titleArea">
                <h2>
                  Olá, <b>{policyData?.policy?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_clientToTB_USERS?.name?.toUpperCase()}</b>
                </h2>
                <h2>DOCUMENTO COMPLEMENTAR: DISCRIMINAÇÃO DE SERVIÇOS</h2>
              </div>
              <div className="logoArea">
                <img src={policyData?.logo} alt="logo" />
              </div>
            </Header>

            <HrHeader />

            <section>
              <SectionContainer>
                <SectionTitle>MGA RESPONSÁVEL</SectionTitle>
              </SectionContainer>

              <Row>
                <b>Nome:</b>
                <p>{policyData?.policy?.TB_PROPOSAL?.TB_PARTNERS?.trade_name}</p>
              </Row>
              <Row>
                <b>CNPJ:</b>
                <p>{formatCNPJ(policyData?.policy?.TB_PROPOSAL?.TB_PARTNERS?.cnpj || '')}</p>
              </Row>
              <Row>
                <b>Razão social:</b>
                <p>{policyData?.policy?.TB_PROPOSAL?.TB_PARTNERS?.social_reason}</p>
              </Row>
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>CLIENTE</SectionTitle>
              </SectionContainer>

              <Row>
                <b>Nome:</b>
                <p>{policyData?.policy?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_clientToTB_USERS?.name}</p>
              </Row>
              <Row>
                <b>CPF/CNPJ:</b>
                <p>{formatCPF(policyData?.policy?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_clientToTB_USERS?.cpf || '')}</p>
              </Row>
              <Row>
                <b>Contato:</b>
                <p>{formatPhone(policyData?.policy?.TB_PROPOSAL?.TB_USERS_TB_PROPOSAL_id_clientToTB_USERS?.phone || '')}</p>
              </Row>
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>REFERÊNCIA DO CONTRATO</SectionTitle>
              </SectionContainer>

              <Row>
                <b>Número do contrato:</b>
                <p>{policyData?.policy?.policy_number}</p>
              </Row>
              <Row>
                <b>Seguradora:</b>
                <p>Split Risk</p>
              </Row>
            </section>

            <section>
              {!!policyData?.products?.filter((product) => product?.value_type === 'value').length && (
                <>
                  <SectionContainer>
                    <SectionTitle>SERVIÇOS DE SEGURO</SectionTitle>
                  </SectionContainer>

                  {policyData?.products?.filter((product) => product?.charge_type === 'unique' && product?.value_type === 'value')
                    .length > 0 && (
                    <table>
                      <thead>
                        <tr>
                          <td width={200}>Serviços de cobrança única</td>
                          <td width={200}>Valor</td>
                        </tr>
                      </thead>
                      <tbody>
                        {policyData?.products
                          ?.filter((product) => product?.charge_type === 'unique' && product?.value_type === 'value')
                          .map((product) => (
                            <tr>
                              <td>{product?.name}</td>
                              <td>{formatCurrency(product?.value || 0)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}

                  {policyData?.products?.filter(
                    (product) => product?.charge_type === 'periodic' && product?.value_type === 'value',
                  ).length > 0 && (
                    <table>
                      <thead>
                        <tr>
                          <td width={200}>Serviços de cobrança recorrente</td>
                          <td width={200}>Valor</td>
                        </tr>
                      </thead>
                      <tbody>
                        {policyData?.products
                          ?.filter((product) => product?.charge_type === 'periodic' && product?.value_type === 'value')
                          .map((product) => (
                            <tr>
                              <td>{product?.name}</td>
                              <td>{formatCurrency(product?.value || 0)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                </>
              )}
            </section>

            <section>
              <>
                <SectionContainer>
                  <SectionTitle>DETALHAMENTO DOS VALORES</SectionTitle>
                </SectionContainer>

                <table>
                  <thead>
                    <tr>
                      <td width={200}>Descrição</td>
                      <td width={200}>Valor</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Prêmio integral da cobertura</td>
                      <td>{formatCurrency(finalValue || 0)}</td>
                    </tr>
                    <tr>
                      <td>Serviços de Seguro</td>
                      <td>{formatCurrency(policyData?.products_sum || 0)}</td>
                    </tr>
                    {policyData?.products?.filter((product) => product?.charge_type === 'unique').length > 0 && (
                      <tr>
                        <td>Primeira parcela</td>
                        <td>
                          {formatCurrency(
                            (policyData?.policy?.value_final || 0) + policyData?.uniquesSum + policyData?.periodicsSum,
                          )}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td>Mensalidade</td>
                      <td>{formatCurrency((policyData?.policy?.value_final || 0) + policyData?.periodicsSum)}</td>
                    </tr>
                  </tbody>
                </table>
              </>
            </section>

            <section>
              <>
                <SectionContainer>
                  <SectionTitle>OBSERVAÇÕES</SectionTitle>
                </SectionContainer>

                <p>
                  Os serviços complementares ao contrato principal e estão sujeitos aos termos e condições estabelecidos pelo seu
                  representante
                </p>
              </>
            </section>
          </Printable>
        </Container>
      )}
      <Footer>
        <FooterRow>
          <FooterText>
            <p>
              Contrato emitida por: <b>{policyData?.policy?.TB_PROPOSAL?.TB_PARTNERS?.social_reason}</b> | CNPJ:{' '}
              {policyData?.policy?.TB_PROPOSAL?.TB_PARTNERS?.cnpj}{' '}
            </p>
          </FooterText>
          <LogoIcon>
            <img src={policyData?.logo || ''} alt="Logo parceiro" />
          </LogoIcon>
        </FooterRow>
      </Footer>
    </>
  );
}

export default PolicySupplementaryDocument;
